/*
 * Copyright (c) 2021 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import { User } from "oidc-client";

export default class GatewayManagementUtil {

    public static getColorForGatewayStatus = (status: string) => {
        let color: any = "grey";
        if (status) {
            let tmpStatus = status.toUpperCase();
            switch (tmpStatus) {
                case "PENDING":
                    color = "yellow";
                    break;
                case "REGISTRATION_PENDING":
                    color = "yellow";
                    break;
                case "REGISTERED":
                    color = "green";
                    break;
                case "DEREGISTERED":
                    color = "red";
                    break;
                case 'UNKNOWN':
                    color = "grey";
                    break;
                default: color = "grey";
            }
        }
        return color;

    }

    public static getLabelForGatewayStatus = (status: string) => {

        let label: any = status;
        if (status) {
            let tmpStatus = status.toUpperCase();
            switch (tmpStatus) {
                case "PENDING":
                    label = "Registration Pending";
                    break;
                case "REGISTERED":
                    label = "Registered";
                    break;
                case "DEREGISTERED":
                    label = "Deregistered";
                    break;
                case "REGISTRATION_PENDING":
                    label = "Registration Pending";
                    break;
                default: label = status;
            }
        }
        return label;

    }

    /**
     * getProject() function will return the project that user has logged In
     * @returns project
     */
    public static getProject = (user: User): string => {
        let customer: string = user!.profile.customer;
        return customer.replace('-default-customer', '');
    }
}
